export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const LOCAL_STORAGE_KEY = 'formshive';
// Empty on dev stacks, so they never post to the live support form.
export const SUPPORT_FORM_URL: string = import.meta.env.VITE_SUPPORT_FORM_URL ?? '';
export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
export const RUSTY_TOOLS_BASE_URL = 'https://blog.formshive.com';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development';
export const IS_DEVELOPMENT = SENTRY_ENVIRONMENT === 'development';
